<template>
  <v-container fluid>
    <v-layout justify-left>
      <v-flex md4 style="max-width: 32%;">
        <jti-expansion-panel panelName="Vehicle Layout Details">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container class="py-0">
              <v-text-field
                v-model="detail.name"
                label="Name"
                :readonly="readonly"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field v-model="detail.floor_count" label="Floor" :readonly="true" mask="#"></v-text-field>
              <v-text-field v-model="detail.column_count" label="Column" :readonly="true"></v-text-field>
              <v-text-field v-model="detail.row_count" label="Row" :readonly="true"></v-text-field>
              <!-- <v-text-field v-model="detail.row_count" label="Row" :readonly="true"></v-text-field> -->
              <v-select
                v-model="detail.vehicle_type_id"
                label="Vehicle Type"
                :items="vehicleTypes"
                :readonly="readonly"
                required
                :rules="[rules.required]"
              ></v-select>
            </v-container>
          </v-form>
        </jti-expansion-panel>
      </v-flex>
      <v-flex md8>
        <v-container>
          <v-layout>
            <v-flex style="margin-top: 170px;">
              <span class="font-weight-black mt-5">BACK</span>
            </v-flex>
            <v-flex>
              <v-layout justify-end v-for="layout in data" :key="layout.index">
                <v-container>
                  <v-layout justify-center>
                    <span class="font-weight-black">Floor: {{layout.floor_no}}</span>
                  </v-layout>
                  <v-layout class="scrolling-wrapper">
                    <v-flex v-for="col in layout.column" :key="col.index">
                      <v-container class="ma-0 pa-0">
                        <v-layout v-for="row in col.data" :key="row.index">
                          <icon-seat
                            v-if="row.status===0"
                            :pointer="true"
                            :seatName="row.seat_name.toString()"
                            color="#0d72b9"
                          ></icon-seat>
                          <icon-seat
                            v-if="row.status===3"
                            :pointer="true"
                            :seatName="row.seat_name.toString()"
                            color="gray"
                          ></icon-seat>
                          <icon-toilet v-if="row.status===4"></icon-toilet>
                          <icon-driver v-if="row.status===5"></icon-driver>
                          <icon-blank v-if="row.status===6"></icon-blank>
                          <icon-door v-if="row.status===7"></icon-door>
                          <icon-blank v-if="row.status===8"></icon-blank>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>
            </v-flex>
            <v-flex style="margin-top: 170px;">
              <span class="font-weight-black">FRONT</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Array,
    detail: Object,
    readonly: Boolean,
    vehicleTypes: Array
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required."
      }
    };
  },
  computed: {
    computedData() {
      return this.detail;
    },
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style>
.scrolling-wrapper {
  overflow-y: hidden;
  width: auto;
  overflow-x: auto;
}
</style>
